import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Spinner, Alert, InputGroup } from "react-bootstrap";
import * as pagosExtraApi from "../../api/pagosExtra";

const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
const HOY = new Date();

/** Alta de un pago extra proyectado: mes/año en que se espera recibirlo + el monto esperado
 * (ej. gratificación de Navidad o de Julio/verano). Los gastos proyectados se agregan después,
 * desde la propia tarjeta ya creada. */
export default function ModalNuevoPagoExtra({ show, onHide, onGuardado }) {
  const [mes, setMes] = useState(HOY.getMonth() + 1);
  const [anio, setAnio] = useState(HOY.getFullYear());
  const [montoEsperado, setMontoEsperado] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) {
      setMes(HOY.getMonth() + 1);
      setAnio(HOY.getFullYear());
      setMontoEsperado("");
      setError("");
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setGuardando(true);
    try {
      await pagosExtraApi.crearPagoExtra(Number(mes), Number(anio), Number(montoEsperado));
      onGuardado();
    } catch (err) {
      setError(err.response?.data?.mensaje || "No se pudo crear el pago extra.");
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Nuevo pago extra</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}
          <div className="row">
            <div className="col-7">
              <Form.Group className="mb-3">
                <Form.Label>Mes</Form.Label>
                <Form.Select value={mes} onChange={(e) => setMes(e.target.value)}>
                  {MESES.map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-5">
              <Form.Group className="mb-3">
                <Form.Label>Año</Form.Label>
                <Form.Select value={anio} onChange={(e) => setAnio(e.target.value)}>
                  {[HOY.getFullYear(), HOY.getFullYear() + 1, HOY.getFullYear() + 2].map((a) => <option key={a} value={a}>{a}</option>)}
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <Form.Group>
            <Form.Label>Monto esperado a recibir</Form.Label>
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control type="number" step="0.01" min="0.01" value={montoEsperado} onChange={(e) => setMontoEsperado(e.target.value)} required autoFocus />
            </InputGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>Cancelar</Button>
          <Button type="submit" variant="primary" disabled={guardando}>
            {guardando ? <Spinner size="sm" animation="border" /> : "Guardar"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
